import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Colors } from "../theme";

export const LoginContain = styled(Box)(() => ({
  backgroundColor: Colors.color,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  "&::before, &::after": {
    content: '""',
    position: "fixed",
    width: "135px",
    height: "135px",
    borderRadius: "50%",
    backgroundColor: Colors.primary,
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    zIndex: 1,
  },
  "&::before": {
    bottom: "-70px",
    left: "-70px",
  },
  "&::after": {
    top: "-70px",
    right: "-70px",
  },
  "& .LoginLogo": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "500px",
    width: "100%",
    margin: "auto",
    "& img": {
      width: "60px",
    },
  },
  "& .LoginCard": {
    maxWidth: "500px",
    width: "100%",
    padding: "40px",
    backgroundcolor: Colors.text,
    borderRadius: "15px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    border:"1px solid "+Colors.border,
    "& .LoginTitle": {
      marginBottom: "30px",
      "& h4": {
        fontSize: "28px",
        color: Colors.primary,
        textAlign: "center",
      },
      "& p": {
        textAlign: "center",
        fontSize: "14px",
        color: "gray",
        marginTop: "5px",
      },
    },
    "& .otp-input-container": {
      display: "flex",
      gap: "10px",
      justifyContent: "center",
      marginBottom: "20px",
      '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
       '& input[type=number]': {
        MozAppearance: 'textfield',
      },
      "& .otp-input": {
        width: "50px",
        height: "50px",
        fontSize: "24px",
        textAlign: "center",
        border: "1px solid #ddd",
        borderRadius: "5px",
        outline: "none",
        transition: "border-color 0.3s ease",
        "&:focus": {
          borderColor: Colors.primary,
        },
      },
    },
    "& .timer-resend-container": {
      display: "flex",
      justifyContent: "center", // Center-align the timer and resend text horizontally
      alignItems: "baseline", // Align items to the same baseline for proper horizontal alignment
      gap: "10px", // Add spacing between the timer and resend text
      marginBottom: "20px", // Add spacing below the container
      "& .timer": {
        fontSize: "14px",
        color: "#333",
      },
      "& .resend-text": {
        fontSize: "14px",
        textDecoration: "underline",
        cursor: "pointer",
        color: Colors.primary,
        transition: "color 0.3s",
        "&.disabled": {
          color: "#ccc",
          cursor: "not-allowed",
        },
        "&.active:hover": {
          color: Colors.hover,
        },
      },
    },
    "& .timer": {
      fontSize: "16px",
      color: "#333",
      textAlign: "center",
      marginBottom: "20px",
    },
    "& .resend-button": {
      backgroundColor: Colors.primary,
      color: Colors.text,
      border: "none",
      padding: "10px 20px",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      marginTop: "10px",
      "&:hover": {
        backgroundColor: Colors.hover,
      },
      "&:disabled": {
        backgroundColor: "#ccc",
        cursor: "not-allowed",
      },
    },
    "& .LoginBtn": {
      textAlign: "center",
      marginTop: "20px",
      "& button": {
        padding: "10px 20px",
        fontSize: "16px",
        backgroundColor: Colors.primary,
        color: Colors.text,
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: Colors.hover,
        },
        "&:disabled": {
          backgroundColor: "#ccc",
          cursor: "not-allowed",
        },
      },
    },
  },
}));

export const LoginFooter = styled(Box)(() => ({
  backgroundColor: "#f5f5f5",
  color: Colors.grayText,
  padding: "10px",
  position: "fixed",
  bottom: "0",
  left: "0",
  width: "100%",
  "& p": {
    margin: "0",
    fontSize: "10px",
    textAlign: "center",
    "& span": {
      color: Colors.primary,
    },
  },
}));

export const Error = styled(Typography)(() => ({
  color: "red",
  fontSize: "12px",
  marginTop: "5px",
  textAlign: "center",
}));